import React from 'react'
import './index.scss'

interface SharesInfoData {
    totalShares?: number | null
    myShares?: number
}

const SharesInfo = (props: SharesInfoData) => {
    const totalKnownShares = props.totalShares ? Math.round(props.totalShares * 100) / 100 : 0
    const myShares = props.myShares ? Math.round(props.myShares * 100) / 100 : 0

    return (
        <div className="shares-info">
            {(props.myShares || props.myShares === 0) && (
                <div>
                    My shares: <span>{myShares}%</span>
                </div>
            )}
            {(props.totalShares || props.totalShares === 0) && (
                <div>
                    Total shares: <span>{totalKnownShares}%</span>
                </div>
            )}
        </div>
    )
}

export default SharesInfo
